import { ACTION_TO_ADD_EXPERIENCE } from 'mk/autogenerated/translations/Article.sagas.78809bf4a12dd21e79d1ce62848e8d32'
import { article_feedback_create_url, wiki_api_get_article_url } from 'mk/urls/functions';
import { FEEDBACK_FORM_NAME } from 'mk2/apps/wiki/components/FeedbackForm';
import {
    ARTICLE_FETCH_TRIGGER,
    articleFetchApi,
    ArticleFetchNormalizedResponse,
    ArticleFetchTriggerAction,
    FEEDBACK_SUBMIT,
    FeedbackSubmitAction,
    WIKI_ARTICLE_ADD_EXPERIENCE,
} from 'mk2/apps/wiki/containers/Article/Article.actions';
import { ArticleEntity, ArticleSchema } from 'mk2/apps/wiki/schemas';
import { handleXHRGetErrorSaga, normalizeError, XHRAction, XHRFormError, XHRGetError } from 'mk2/helpers/api';
import { handleXHRFormErrorSaga, handleXHRFormSuccessSaga } from 'mk2/helpers/form';
import { getLogger } from 'mk2/logger';
import { checkIfUserIsLoggedIn } from 'mk2/sagas/auth';
import { normalize } from 'normalizr';
import { all, call, put, takeEvery, takeLatest } from 'redux-saga/effects';

const logger = getLogger('wiki/Article.sagas');

interface ApiResponseArticle {
    body: {
        article: ArticleEntity;
    };
}

function* fetchArticle({ articleSlug, categorySlug, xhr }: ArticleFetchTriggerAction & XHRAction) {
    yield put(articleFetchApi.request(articleSlug, categorySlug));

    try {
        const response: ApiResponseArticle = yield call(
            () => xhr.get(wiki_api_get_article_url(), { articleSlug, categorySlug }),
        );

        const normalizedResponse: ArticleFetchNormalizedResponse = normalize(response.body, {
            article: ArticleSchema,
        });
        yield put(articleFetchApi.success(articleSlug, categorySlug, normalizedResponse));
    } catch (error) {
        yield handleXHRGetErrorSaga(error as XHRGetError, logger);
        yield put(articleFetchApi.failure(articleSlug, categorySlug, normalizeError(error)));
    }
}

interface ApiResponseFeedbackCreate {
    body: {
        result: string;
    };
}
function* createFeedback({ articleSlug, feedbackFd, xhr }: FeedbackSubmitAction & XHRAction) {
    try {
        const response: ApiResponseFeedbackCreate = yield call(
            () => xhr.post(article_feedback_create_url(), {
                articleSlug,
                feedbackFd,
            }),
        );
        yield handleXHRFormSuccessSaga(FEEDBACK_FORM_NAME);
    } catch (error) {
        yield handleXHRFormErrorSaga(FEEDBACK_FORM_NAME, error as XHRFormError, logger);
    }
}

function* wikiArticleExperience() { /* this saga runs only in case the user is not logged in */

    if (!(yield call(checkIfUserIsLoggedIn, ACTION_TO_ADD_EXPERIENCE))) {
        return;
    }

}

export default function* root() {
    yield all([
        takeLatest(ARTICLE_FETCH_TRIGGER, fetchArticle),
        takeEvery(FEEDBACK_SUBMIT, createFeedback),
        takeEvery(WIKI_ARTICLE_ADD_EXPERIENCE, wikiArticleExperience),
    ]);
}
